
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SalesRatioControlHintBanner',
  props: {},
  setup() {
    return {};
  }
});
